import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '@/components/base/Button';
import ScrollManager from '@/components/feature/ScrollManager';
import { navLinks } from '@/mocks/home';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isActive = (href: string) => (href === '/' ? pathname === '/' : pathname === href || pathname.startsWith(`${href}/`));

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled || open ? 'bg-background-50/95 border-b border-background-300' : 'bg-transparent'}`}>
      <ScrollManager />
      <nav className="flex items-center justify-between h-[72px] px-4 md:px-10 lg:px-[56px]" aria-label="Main">
        <Link to="/" className="font-heading text-xl font-semibold tracking-[0.18em] text-foreground-950 cursor-pointer">CLEARY</Link>
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <li key={l.href}><Link to={l.href} aria-current={isActive(l.href) ? 'page' : undefined} className={`relative py-1 text-sm font-medium text-foreground-950 hover:text-secondary-500 transition-colors whitespace-nowrap cursor-pointer after:absolute after:left-0 after:right-0 after:-bottom-0.5 after:h-[2px] after:rounded-full after:bg-secondary-500 after:transition-transform after:duration-300 after:origin-left ${isActive(l.href) ? 'after:scale-x-100' : 'after:scale-x-0'}`}>{l.label}</Link></li>
          ))}
        </ul>
        <div className="hidden md:block"><Button href="/contact">Get a Quote</Button></div>
        <button type="button" className="md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer whitespace-nowrap text-foreground-950" aria-label="Toggle menu" aria-expanded={open} onClick={() => setOpen(!open)}>
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
        </button>
      </nav>
      {open && (
        <div className="md:hidden px-4 pb-6 bg-background-50">
          <ul className="flex flex-col border-t border-background-300">
            {navLinks.map((l) => (
              <li key={l.href}><Link to={l.href} onClick={() => setOpen(false)} aria-current={isActive(l.href) ? 'page' : undefined} className={`flex items-center gap-2 py-4 text-base border-b border-background-300 cursor-pointer ${isActive(l.href) ? 'text-secondary-500 font-medium' : ''}`}>{isActive(l.href) && <span className="w-1.5 h-1.5 rounded-full bg-secondary-500" />}{l.label}</Link></li>
            ))}
          </ul>
          <Button href="/contact" className="w-full mt-5">Get a Quote</Button>
        </div>
      )}
    </header>
  );
}